import VisualPositioningManager from "./visual-positioning-manager"

const debug = false
// const debug = "DndManager"

export default class DndManager {

    dragStarted             : boolean

    dndLayers               : any

    registeredDropTargets   : any[]
    registeredDragSources   : any[]
    draggedOver             : any[]

    lastMousePosition       : any
    dragOverTestThrottle    : any

    visualPositioningManager: VisualPositioningManager

    draggedItem             : any
    dragStartData           : any

    constructor(options = {}) {
        debug && console.log(debug, 'constructor')

        const _options = _.assign({
            visualHorizontalDivisions: 2,
            visualVerticalDivisions: 2,
        }, options)

        this.dragStarted = false;

        this.dndLayers = {};

        this.registeredDropTargets = [];
        this.registeredDragSources = [];
        this.draggedOver = [];

        this.setDraggedItem(null);
        this.lastMousePosition = null;

        this.dragOverTestThrottle = _.throttle(this.__dragOverTest, 16);

        this.visualPositioningManager = new VisualPositioningManager(_options.visualHorizontalDivisions,_options.visualVerticalDivisions);
    }

    addWindowListeners() {
        window.addEventListener("mousemove", this.dragOverTest, true);
        window.addEventListener("mouseup", this.drop, true);

        this.visualPositioningManager.addWindowListeners();
    }

    removeWindowListeners() {
        window.removeEventListener("mousemove", this.dragOverTest, true);
        window.removeEventListener("mouseup", this.drop, true);

        this.visualPositioningManager.removeWindowListeners();
    }

    registerDndLayer(layer: any, name='default') {
        if (_.has(this.dndLayers, name)) {
            console.warn(this.constructor.name + ": layer with name " + name + " is already registered");
        } else {
            // @ts-ignore
            this.dndLayers[name] = layer;
        }
    }

    unregisterDndLayer(layer: any, name='default') {if (_.has(this.dndLayers, name)) delete this.dndLayers[name]}

    setDraggedItem(value: any) {this.draggedItem = value}
    getDraggedItem() {return this.draggedItem}
    isDraggedItem(dndId: ID) {return !!this.getDraggedItem() && this.getDraggedItem().getDNDId() === dndId}

    addDropTarget(target: any) {
        debug && console.log(debug, 'addDropTarget', target)

        this.registeredDropTargets.push(target);

        if (this.dragStarted && target.canDrop(this.getDraggedItem())) {
            this.visualPositioningManager.addTarget(target);
        }
    }

    removeDropTarget(target: any) {
        debug && console.log(debug, 'removeDropTarget', target)

        this.registeredDropTargets.remove(target);
        this.visualPositioningManager.removeTarget(target);
    }

    addDragSource(source: any) {
        // remove old one if present
        _.remove(this.registeredDragSources, registeredSource => registeredSource.getDNDId() === source.getDNDId())

        this.registeredDragSources.push(source)
        if (this.isDraggedItem(source.getDNDId())) {
            if (this.getDraggedItem()) source.copyDraggedItemPositions(this.getDraggedItem());
            this.setDraggedItem(source);
        }
    }

    removeDragSource(source: any) {
        if (this.isDraggedItem(source.getDNDId())) return
        this.registeredDragSources.remove(source)
    }

    getMousePositionDelta(e: any) {
        return {
            dx: e.clientX - this.lastMousePosition.x,
            dy: e.clientY - this.lastMousePosition.y
        };
    }

    getDraggedOver() {return this.draggedOver}

    _showPreview(item: any, mouseEvent: any) {
        _.mapKeys(this.dndLayers, (layer,key)=>{
            layer.showPreview(item, mouseEvent)
        })
    }

    _hidePreview() {_.mapKeys(this.dndLayers, (layer,key)=>{layer.hidePreview()})}
    _updatePreview(dx?: number, dy?: number) {_.mapKeys(this.dndLayers, (layer,key)=>{layer.updatePreview(dx, dy)})}

    setDragStarted = (value: boolean) => {
        this.dragStarted = value;
        gd.bus.triggerEvent('dnd-manager:drag-started', this);
    }

    dragStart(source: any, mouseEvent: any) {
        // this.dragStarted = true;
        this.lastMousePosition = {x: mouseEvent.clientX, y: mouseEvent.clientY};

        const components = _.filter(this.registeredDropTargets, t=>t.canDrop(source));
        const rectRetrievalFunction = (t: any)=>t.getComponentNode().getBoundingClientRect();
        this.visualPositioningManager.init(components, rectRetrievalFunction);
        this.updateBlockTargets();

        this.setDraggedItem(source);
        this._showPreview(this.getDraggedItem(), mouseEvent);
        this.dragStartData = source.onDragStart();
        this.addWindowListeners();

        debug && console.log(debug, 'dragStart components', components, this.visualPositioningManager)

        this.__dragOverTest(mouseEvent); //one first immediate test
    }

    isDragging = () => this.dragStarted;

    dragOverTest = (mouseEvent: any) => {this.dragOverTestThrottle(mouseEvent);}

    updateBlockTargets = () => {this.visualPositioningManager.collectBlockTargets()}

    __isOverlapping(m: any, t: any) {
        return !(   m.clientX < t.left   ||
                    m.clientX > t.right  ||
                    m.clientY < t.top    ||
                    m.clientY > t.bottom);
    }

    //mouse position test
    __dragOverTest(mouseEvent: any) {
        const draggedItem = this.getDraggedItem();
        if (!draggedItem) return;

        const prevDraggedOver = this.draggedOver.slice();
        let newDraggedOver: any[] = [];

        const blockTargets = this.visualPositioningManager.getAppropriateBlock(mouseEvent);

        blockTargets.map(t=>{
            const tRect = t.getComponentNode().getBoundingClientRect();
            if (this.__isOverlapping(mouseEvent, tRect)) {
                newDraggedOver.push(t);
            }
        });
        newDraggedOver = _.orderBy(newDraggedOver, t=>t.props.dndZIndex, ['desc']); //more dndZIndex value is on top

        this.draggedOver = newDraggedOver;

        // console.log("DndManager __dragOverTest", blockTargets, newDraggedOver);

        _.difference(prevDraggedOver, newDraggedOver).map(t=>{if(this.registeredDropTargets.includes(t)) t.onDraggedOut(this.getDraggedItem())});
        _.difference(newDraggedOver, prevDraggedOver).map(t=>{if(this.registeredDropTargets.includes(t)) t.onDraggedOver(this.getDraggedItem(), mouseEvent)});

        this.draggedOver.map(t=>{if(this.registeredDropTargets.includes(t)) t.onDraggingOver(this.getDraggedItem(), mouseEvent)});

        const { dx, dy } = this.getMousePositionDelta(mouseEvent);
        this.getDraggedItem().onDrag(dx, dy);
        this._updatePreview(dx, dy);
    }

    drop = (mouseEvent: any) => {
        if (!this.dragStarted) return;
        const { dx, dy } = this.getMousePositionDelta(mouseEvent);

        this.setDragStarted(false);

        this.removeWindowListeners();
        this._hidePreview();

        let dropResult = {};
        if (this.dragStartData) dropResult = _.assign(dropResult, this.dragStartData);

        this.draggedOver.map(t=>{
            t.onDraggedOut(this.getDraggedItem(), true);
            dropResult = t.onDrop(this.getDraggedItem(), dropResult);
        });

        this.draggedOver = [];
        const draggedItemId = this.getDraggedItem().getDNDId();
        this.setDraggedItem(null);
        this.lastMousePosition = null;

        const sourcesSlice = this.registeredDragSources.slice() // required in case new sources are added while processing
        _.map(sourcesSlice, s=>{
            if (s.getDNDId() === draggedItemId) s.onDragEnd(mouseEvent, dx, dy, dropResult);
        });

        this.visualPositioningManager.flush();
    }
}